// Components
import { Box } from '@mui/material';
import styled from 'styled-components';

const CustomBox = styled(Box)({
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export default CustomBox;